import { render, staticRenderFns } from "./StudentMarkCell.vue?vue&type=template&id=a1209162"
import script from "./StudentMarkCell.vue?vue&type=script&lang=js"
export * from "./StudentMarkCell.vue?vue&type=script&lang=js"
import style0 from "./StudentMarkCell.vue?vue&type=style&index=0&id=a1209162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports